// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-menu__container {
    padding: 18px 16px;
    height: 130vh;
}

.search-menu__container .baloa-headline-2{
    color: var(--primary-very-dark-color);
    margin-bottom: 24px;
}

.search-menu__button {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
    justify-items: flex-start;
    padding: 10px;
    border-radius: 4px;
    color: var(--primary-dark-color);
    cursor: pointer;
}

.search-menu__button .icon {
    grid-area: icon;
    font-size: 24px;
    margin-right: 10px;
}

.search-menu__button .baloa-normal-medium {
    color: var(--primary-dark-color);
}

.search-menu__button .hubicon-all {
    color: var(--primary-dark-color);
}

.search-menu__button.active {
    background: var(--new-green-color);
    color: var(--white-color);
}

.search-menu__button.active .baloa-normal-medium {
    color: var(--white-color);
}



.search-menu__button.active .hubicon-all::before,
.search-menu__button.active .hubicon-pages_v2::before,
.search-menu__button.active .hubicon-post_fill::before,
.search-menu__button.active .hubicon-tournament_fill::before,
.search-menu__button.active .hubicon-team_fill::before,
.search-menu__button.active .hubicon-roles_fill::before
{
    color: var(--white-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .search-menu__container.mobile-container {
        height: auto;
        display: flex;
        gap: 10px;
        padding: 8px 0;
        overflow-x: auto;
    }

    .search-menu__button.mobile-button {
        border-radius: 25px;
        border: 1px solid var(--primary-dark-color);
        background: var(--white-color);
        padding: 8px;
        margin: 0;
    }

    .search-menu__button .baloa-table {
        color: var(--primary-dark-color);
    }

    .search-menu__button.mobile-button.active {
        border: 1px solid var(--new-green-color);
        background: #EAF7F0;        
    }

    .search-menu__button.active .baloa-table {
        color: var(--new-green-color);
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/search/components/search-menu/SearchMenuComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;;;;;;;IAOI,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;QACZ,aAAa;QACb,SAAS;QACT,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,2CAA2C;QAC3C,8BAA8B;QAC9B,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,wCAAwC;QACxC,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".search-menu__container {\n    padding: 18px 16px;\n    height: 130vh;\n}\n\n.search-menu__container .baloa-headline-2{\n    color: var(--primary-very-dark-color);\n    margin-bottom: 24px;\n}\n\n.search-menu__button {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 12px;\n    justify-items: flex-start;\n    padding: 10px;\n    border-radius: 4px;\n    color: var(--primary-dark-color);\n    cursor: pointer;\n}\n\n.search-menu__button .icon {\n    grid-area: icon;\n    font-size: 24px;\n    margin-right: 10px;\n}\n\n.search-menu__button .baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n\n.search-menu__button .hubicon-all {\n    color: var(--primary-dark-color);\n}\n\n.search-menu__button.active {\n    background: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.search-menu__button.active .baloa-normal-medium {\n    color: var(--white-color);\n}\n\n\n\n.search-menu__button.active .hubicon-all::before,\n.search-menu__button.active .hubicon-pages_v2::before,\n.search-menu__button.active .hubicon-post_fill::before,\n.search-menu__button.active .hubicon-tournament_fill::before,\n.search-menu__button.active .hubicon-team_fill::before,\n.search-menu__button.active .hubicon-roles_fill::before\n{\n    color: var(--white-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .search-menu__container.mobile-container {\n        height: auto;\n        display: flex;\n        gap: 10px;\n        padding: 8px 0;\n        overflow-x: auto;\n    }\n\n    .search-menu__button.mobile-button {\n        border-radius: 25px;\n        border: 1px solid var(--primary-dark-color);\n        background: var(--white-color);\n        padding: 8px;\n        margin: 0;\n    }\n\n    .search-menu__button .baloa-table {\n        color: var(--primary-dark-color);\n    }\n\n    .search-menu__button.mobile-button.active {\n        border: 1px solid var(--new-green-color);\n        background: #EAF7F0;        \n    }\n\n    .search-menu__button.active .baloa-table {\n        color: var(--new-green-color);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
